module.exports = __webpack_public_path__ + "static/media/Screenshot_4.18a1573b.png";